// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9022f749","239":"0d319efe","455":"59fed230"}[chunkId] + ".chunk.js";
};